export interface Well {
  id: string;
  name: string;
  well_Latitude?: number;
  well_Longitude?: number;
  kbelevation_ft?: number;
  total_depth_md_ft?: number;
  total_depth_tvd_ft?: number;
  spud_date?: string;
  operator?: string;
  status?: string;
  imageUrl?: string;
}

export interface ProductionData {
  date: string;
  oil?: number;
  gas?: number;
  water?: number;
}

export interface DashboardTile {
  id: string;
  title: string;
  value: string | number;
  icon: string;
  color: string;
  link?: string;
}

export interface CardData {
  type_id: string;
  osdu_id: string;
}

export enum IVAAPCardType {
  TEMPLATE = 'template',
  DASHBOARD = 'dashboard',
}

export interface CardViz {
  viz: {
    dashboard_id: string;
    ivaap_url: string[];
    type:  IVAAPCardType
  };
}

export interface Card {
  title: string;
  type: string;
  id: string;
  data?: CardData[];
}

export interface CardResponse {
  results: Card
}
